/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   Multi MessagingModal actions
 */

import type { MultiMessageModal } from '@zcode/state-type'
import { createAction } from 'redux-actions'
import { CLEAR_DATA, RECEIVE_DATA } from '../constants/multiMessageModal'

export const receiveMultiMessageData = createAction<MultiMessageModal, typeof RECEIVE_DATA>(
  RECEIVE_DATA
)
export const clearMultiMessageData = createAction(CLEAR_DATA)
